import React from 'react';
import { Tooltip } from 'antd';

export const Shorten = ({ text, digits }: { text: string; digits: number }) => {
  return <>{text.length > digits ? <Tooltip title={text}>{text.slice(0, digits)}...</Tooltip> : text}</>;
};
